import { render, staticRenderFns } from "./importBill.vue?vue&type=template&id=f4318202&scoped=true"
import script from "./importBill.vue?vue&type=script&lang=js"
export * from "./importBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4318202",
  null
  
)

export default component.exports